package com.sddamico.swigmore.models

import kotlinx.serialization.Serializable

@Serializable
data class SendOtpRequest(val email: String)

@Serializable
data class VerifyRequest(val email: String, val code: String)

@Serializable
data class MeResponse(val id: String, val email: String, val isAdmin: Boolean, val name: String?)

/** [me] is null when signed out, which is an answer rather than an error. */
@Serializable
data class SessionResponse(val me: MeResponse?)

/** [pushEndpoint] un-enrolls this browser, so the account's alerts stop arriving after sign-out. */
@Serializable
data class LogoutRequest(val pushEndpoint: String? = null)
